// Per-Segment wallpaper pattern-colour seed (pure — no React, no I/O).
//
// <Wallpaper> (Shared/Wallpaper/index.jsx) calls `handlePatternColorInitialChange`
// on mount whenever `patternColor` is undefined — i.e. on every bare SELECT of a
// segment whose `settings.wallpaper` has no pattern colour yet. That call is a
// render echo, not a user edit, so it must never change the save payload unless
// the colour is actually needed.
//
// A pattern colour is only ever painted while the wallpaper is in pattern mode
// (`currentBg === 1`, see SegmentView/index.jsx and pages/Segment/index.jsx), so:
//   * not in pattern mode  -> nothing to seed; writing would only dirty the wheel
//     (T10.4: "Unsaved changes" + autosave PUT right after selecting a segment);
//   * already has a colour -> nothing to seed (never clobber a real pick);
//   * pattern mode, no colour (a pattern was just picked on a fresh segment)
//     -> seed the colour, leaving `currentBg` alone. The old seed forced
//     `currentBg: 0`, which would have switched a just-picked pattern off.

/**
 * @param {object} wallpaper the segment's current `settings.wallpaper` (copy)
 * @param {string} color the resolved seed colour
 * @returns {object|null} the wallpaper to write, or null when no write is needed
 */
export const seedPatternColorWallpaper = (wallpaper, color) => {
  const wp = wallpaper || {};
  if (wp.currentBg !== 1 || wp.patternColor !== undefined) return null;
  return { ...wp, patternColor: color };
};
